import type { Track } from 'types/track'

/** Mixpanel context for previews, drags and adds from the suggestions panel. */
export const SUGGESTIONS_CONTEXT = 'Suggested tracks'

export const ADD_SUGGESTED_TRACK_EVENT = 'Add suggested track to playlist'

// Matches the Destination of `Drag and drop item(s)` into a playlist.
const PLAYLIST_CREATOR_LOCATION = 'Playlist creator'

type SuggestionsSearch = {
  searchId?: string
  resultsSource: 'DISCO' | 'AIMS'
}

/**
 * What a dragged suggestion carries, so `Drag and drop item(s)` reports the
 * suggestions panel as its source, like Browse search results do.
 */
export const getSuggestionDragData = (
  track: Track,
  { searchId, resultsSource }: SuggestionsSearch,
) => ({
  track,
  location: PLAYLIST_CREATOR_LOCATION,
  context: SUGGESTIONS_CONTEXT,
  source: SUGGESTIONS_CONTEXT,
  searchType: 'Similarity',
  searchId,
  resultsSource,
})

/** Properties of the event sent when a suggestion is added with +. */
export const getAddSuggestionProps = (
  track: Track,
  position: number,
  { searchId, resultsSource }: SuggestionsSearch,
) => ({
  'Track ID': track.id,
  Position: position,
  Location: PLAYLIST_CREATOR_LOCATION,
  Context: SUGGESTIONS_CONTEXT,
  Search: 'Similarity',
  'Search ID': searchId,
  Source: resultsSource,
})
